import { render, staticRenderFns } from "./MesaNewVincularMesas.vue?vue&type=template&id=4d4521c7&scoped=true"
import script from "./MesaNewVincularMesas.vue?vue&type=script&lang=js"
export * from "./MesaNewVincularMesas.vue?vue&type=script&lang=js"
import style0 from "./MesaNewVincularMesas.vue?vue&type=style&index=0&id=4d4521c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4521c7",
  null
  
)

export default component.exports